import { Injectable } from '@angular/core';
import { AngularFireDatabase  } from 'angularfire2/database/database';
//import { DateTime } from 'ionic-angular';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AuthProvider } from '../providers/auth/auth';

@Injectable()
export class PartesService{
  constructor(public afDB: AngularFireDatabase,public auth : AuthProvider,){
    this.usuario =  this.getUsuario();
    this.getTodoPersonal();
    /*this.getPersonal()
        .subscribe(personal => {
            this.personal = personal;
        });*/
  }

  usuario : string;
  personal = [];
  public temparr = [];
  /*public editFichada(fichada,fecha,ficha,hora){
    this.afDB.database.ref('/fichadas/' + this.usuario + '/' + fecha + '/' + ficha+'-'+hora.substring(0,hora.length - 3)).set(fichada);
    //this.afDB.database.ref('/fichadas/' + this.usuario + '/' + fecha + '/' + ficha + '-' + hora).push(fichada);
  }*/ 
  public editFichada(fichada, fecha, ficha){
    this.afDB.database.ref('/fichadas/' + this.usuario + '/' + fecha.substring(0,4) + '/' + fecha + '/' + ficha).set(fichada);
  }
  //Añadir,editar y eliminar Partes    
  
      public editParte(parte){
        this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).set(parte);
      } 

      public deleteParte(parte){
        this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).remove();
      }

      /*//Devuelve el numero de Unidades de las lineas de un Parte
      public countUnidades(parte){
        let Unidades = parseInt("0");
        for (let i = 0; i < parte.lineas.length; i++){
          Unidades = Unidades + parseInt(parte.lineas[i].Unidades);
        }
        return Unidades;
      }
      */
    public getFichadasOrdenado(Fecha){
      return this.afDB.list('/fichadas/' + this.usuario + '/'+ Fecha.substring(0,4) + '/'  + Fecha + '/',{query:{orderByChild: 'Ficha'}});
    }
      public getPartesOrdenado(){
        return this.afDB.list('/encargados/' + this.usuario + '/partes/',{query:{orderByChild: 'Orden'}});
      }
      public getPartes(){
        return this.afDB.list('/encargados/' + this.usuario + '/partes/');
      }
      public refreshPersonal(idCuadrilla){
        this.getPersonalCuadrilla(idCuadrilla)
        .subscribe(personal => {
            this.personal = personal;
        });
      }
      
      /*public getTodoPersonal(){
        return this.afDB.list('/personal/1/',{query:{orderByChild: 'Nombre'}});
      }*/

      public getNombre(id){
        let Nombre : string;
        Nombre = "";
        this.afDB.database.ref('/personal/').orderByChild('uid').once('value', snapshot => {
          let catData = snapshot.val();
          let temparr = [];
          for (var key in catData) {
            for (var key2 in catData[key]) { // <= for nuevo
              if(catData[key][key2].id == id) Nombre = catData[key][key2].Nombre; 
            }
          }
                 
      });//alert("services:  "  + Nombre);
      return Nombre;   
      }


      public getTodoPersonal(){
        let Nombre : string;
        Nombre = "";
        this.afDB.database.ref('/personal/').orderByChild('uid').once('value', snapshot => {
          let catData = snapshot.val();
          let temparr = [];
          for (var key in catData) {
            for (var key2 in catData[key]) { // <= for nuevo
              this.temparr.push(catData[key][key2]) 
            }
          }
                 
      });}

      /*public getTodoPersonal(){
        return this.afDB.list('/personal/');
      }*/

      public getPersonalCuadrilla(idCuadrilla){
        return this.afDB.list('/personal/'+ idCuadrilla +'/',{query:{orderByChild: 'Nombre'}});
      }
         
      public getCuadrillas(){
        return this.afDB.list('/encargados/' + this.usuario + '/cuadrillas/',{query:{orderByChild: 'Nombre'}});
      }  

      public getFincas(){
        return this.afDB.list('/encargados/' + this.usuario + '/fincas/',{query:{orderByChild: 'Nombre'}});
      }  

      public getFincasEmpresa(idEmpresa){
        return this.afDB.list('/encargados/' + this.usuario + '/fincas/',{query:{orderByChild: 'idEmpresa',equalTo : idEmpresa}});  
      }      

      public getTareas(){
        return this.afDB.list('/tareas/',{query:{orderByChild: 'Nombre'}});
      }  

      public getUsuario(){
        let strUsuario : string;
        strUsuario = this.auth.getUser();
        strUsuario = strUsuario.substring(0,2);
        return strUsuario;
      }

      //Devuelve el idParte siguiente.
      getIdParte(){
        let strUsuario : string;
        let usuario : number;
        let partesArray = [];

        strUsuario = this.auth.getUser();
        strUsuario = strUsuario.substring(1,2);
        usuario = parseInt(strUsuario);

        this.getPartes()
        .subscribe(partes => {
            partesArray = partes;
        });

        if (partesArray.length <= 0){
          return 180000 + usuario * 1000;
        }
        else{
          return partesArray[partesArray.length - 1].id;
        }
      }
}


// WEBPACK FOOTER //
// ./src/services/partes.services.ts